/**
 * Fade-in on scroll
 *
 * `.fade-in` クラスが付いた要素が viewport に入ったら `.is-visible` を付与。
 * CSS 側の transition でフェードインさせる。
 * `data-fade-delay="<ms>"` で個別ディレイ可。
 */
export const initFadeIn = () => {
  const els = document.querySelectorAll('.fade-in');
  if (!els.length) return;

  // モーション抑制設定の人にはすぐに表示
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const delay = entry.target.dataset.fadeDelay;
        if (delay) {
          entry.target.style.transitionDelay = `${delay}ms`;
        }
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -60px 0px',
    }
  );

  els.forEach((el) => io.observe(el));
};



